import { useMutation, useQueryClient } from "@tanstack/react-query";
import { raffleKeys } from "Api/Queries/Raffle/useRaffleCurrentQuery";
import {
  type MoveRaffleTicketsRequest,
  type RaffleTicketMoveResultDto,
  postRaffleTicketsMove,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: RaffleTicketMoveResultDto) => void;
  onError?: (error: unknown) => void;
};

/**
 * Moves the caller's tickets between two open competitions of their market (R7). Report the
 * returned count, not the requested one: a concurrent refund may have revoked some tickets.
 */
export const useMoveRaffleTicketsMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (request: MoveRaffleTicketsRequest) => postRaffleTicketsMove(request),
    ),
    onSuccess,
    onError,
    // Refresh on failure too: a 409 means the offered counts or competitions are outdated.
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: raffleKeys.all });
    },
  });
};
